export const toLevelOption = (level: number) => ({ label: `Level ${level}`, value: level });

export const toLessonOption = (lesson: number) => ({ label: `Lesson ${lesson}`, value: lesson });
